import React from "react";
import style from "../styles/spinner.module.css";
export default function spinner() {
  return (
    <div className={style.spinner__container}>
      <div className={style.spinner__body}></div>
    </div>
  );
}
